import axios from 'axios'
import router from './router'
import {
  store
} from './store'

export const HTTP = axios.create({
  // baseURL: `https://gqnchpomjprsrfglg-mock.stoplight-proxy.io`,
  // baseURL: 'https://sim-activation-server-dev.herokuapp.com/api',
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json'
    // Authorization: 'Bearer {token}'
  }
})

HTTP.interceptors.response.use((response) => {
  return response;
}, (err) => {
  if (err.response && typeof err.response.status !== "undefined" && err.response.status === 401 && err.config && !err.config.__isRetryRequest) {
    console.log('401 detected')
    store.dispatch('logout')
    router.replace({
      path: '/login?timeout=1'
    })
  }
  // console.log(err.request);
  // const error = err.request.status < 500 ? err : JSON.parse(err.request.response).error;
  // error.status = err.request.status;
  // console.log(error);
  throw err;
})



// WEBPACK FOOTER //
// ./src/http-common.js